module.exports = __webpack_public_path__ + "static/img/10.6b3991f8.jpg";